export default "__VITE_ASSET__CICPQ1wK__"